import axios from '@/modules/axios';

function loadChannels() {
	return axios.get('/channels');
}

function createChannels(payload) {
	return axios.post('/channels', payload);
}

function loadChannelsById() {

}

function updateChannels(channelId, payload) {
	return axios.put(`/channels/${channelId}`, payload);
}

function deleteChannels() {

}


export {
	loadChannels,
	createChannels,
	loadChannelsById,
	updateChannels,
	deleteChannels,
};



// WEBPACK FOOTER //
// ./src/modules/api/Channel.js